import { RouteConfig } from 'vue-router';
import SubscriptionReport from './my-reports.component.vue';
import CloudReport from './cloud-reports.component.vue';
// const route : RouteConfig = {
//   path:  'subscrreport',
//   component: SubscriptionReport,
// };

export const MyReportsRoute: RouteConfig = {// tslint:disable-line:variable-name
  path:'subscrreport',
  component:SubscriptionReport,
};

export const CloudReportsRoute: RouteConfig = {// tslint:disable-line:variable-name
  path:'cloudreport',
  component:CloudReport,
};

export function getDefaultParams() {
  return {};
}
// export default route;
